var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlightGoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0228 12L11.6895 15.3333L10.7559 14.3665L12.4564 12.6667H6.35612V11.3333H12.4564L10.7559 9.63346L11.6895 8.66666L15.0228 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2565 5.61328L13.7643 4.67317C14.2977 4.5304 14.846 4.84686 14.9889 5.3802C15.1318 5.91359 14.8152 6.46178 14.2819 6.60481L3.83724 9.40364C3.54182 9.48278 3.23052 9.35069 3.08203 9.08333L1.33333 5.93359L2.29948 5.67447L3.94466 7.30468L7.34114 6.39388L4.33398 1.67838L5.62239 1.33333L10.2565 5.61328Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlightGoing);
export default __webpack_public_path__ + "static/media/iconFlightGoing.c4f5fd4dfaf9b40fc0a7c6f2b2acfb68.svg";
export { ForwardRef as ReactComponent };